import { hasAnyAccess } from "helper/access-permission"
import { useEffect, useState } from "react";
import { UseAuth } from "hook/auth-hook";
import { RestUseCase } from "service/api/rest/rest-usecase";
import { handleRequest } from "service/api/request-common";
import ErrorNotAuthorizedPage from "pages/layout/error/error-not-authorized-page";
import { IndicatodFilterPlanningAdapter } from "helper/adapter/planning/indicator-filter-planning-adapter";
import { SelectOptionInterface } from "../../../@types/entity/interface/select-option-interface";
import { HeaderNavegationList } from "helper/adapter/headerNavigation/header-navegation-adapter";
import IndicatorPageV2 from "pages/layout/analysis/indicator-page-v2";
import { getEnv } from "helper/window-helper"

export const IndicatorFactory: React.FC = () => {

    const ENDPOINT_TABLE_PUNCTUATION = getEnv("REACT_APP_END_POINT_INDICATOR")
    const ENDPOINT_PLANNING = getEnv("REACT_APP_END_POINT_INDICATOR") + "/filtros"
    const ENDPOINT_EXCEL = getEnv("REACT_APP_END_POINT_INDICATOR") + "/gerar-excel"

    /** VERIFICA PERMISSAO DE ACESSO */
    const { loggedUserData } = UseAuth();
    const [showScreen, updateShowScreen] = useState<boolean>(false);
    useEffect(() => {
        const roleScreen = HeaderNavegationList.filter(
            (header) => header.navTitle === "Análise"
        )[0].navItem.filter((item) => item.title === "Indicador")[0].access;

        if (hasAnyAccess(loggedUserData?.access, roleScreen)) {
            updateShowScreen(true)
        }
        updateShowScreen(true);
    }, [loggedUserData]);

    const [filial, updateFilial] = useState<SelectOptionInterface[]>([])
    const [uf, updateUf] = useState<SelectOptionInterface[]>([])
    const [marca, updateMarca] = useState<SelectOptionInterface[]>([])
    const [discountGroup, updateDiscountGroup] = useState<SelectOptionInterface[]>()
    const [base, updateBase] = useState<SelectOptionInterface[]>()
    const [rangeProfitability, updateRangeProfitability] = useState<SelectOptionInterface[]>()
    const ENDPOINT_FILIAL = getEnv("REACT_APP_END_POINT_FILIAL")!
    const ENDPOINT_MANUFACTURER = getEnv("REACT_APP_END_POINT_MANUFACTURER")
    const END_POINT_ORIGINAL_ITEMS_TRACKS = getEnv("REACT_APP_END_POINT_ORIGINAL_ITEMS_TRACKS")!
    const END_POINT_ITEM_TRACKS = getEnv("REACT_APP_END_POINT_ITEM_TRACKS")!
    const END_POINT_ITEM_BASE = getEnv("REACT_APP_END_POINT_ITEM_BASE")!
    const END_POINT_ITEM_BASE_CODE = getEnv('REACT_APP_END_POINT_ITEM_BASE_CODE')!;

    const handleFilial = async () => {
        await new RestUseCase(`${ENDPOINT_FILIAL}?modulos=COMPRAS`).Get().then((response) => {
            const filiais = response.body || [];
            updateFilial(
                filiais.map((value: any) => {
                    return { value: value.id, label: value.nome };
                })
            );
            const ufs = filiais
                .map((value: any) => value.uf)
                .filter((value: any) => !!value)
                .map((value: string) => value.toUpperCase());
            updateUf(
                Array.from(new Set<string>(ufs))
                    .sort()
                    .map((value) => ({ value, label: value }))
            );
        });
    };

    const handleDiscountGroup = async () => {
        await new RestUseCase(END_POINT_ORIGINAL_ITEMS_TRACKS)
            .Get()
            .then((response) => {
                updateDiscountGroup(
                    response.body.map((value: any) => {
                        return { value: value, label: value };
                    })
                );
            });
    };
    const handleRangeProfitability = async () => {
        await new RestUseCase(END_POINT_ITEM_TRACKS).Get().then((response) => {
            updateRangeProfitability(
                response.body.map((value: any) => {
                    return { value: value, label: value };
                })
            );
        });
    };
    const handleBase = async () => {
        await new RestUseCase(END_POINT_ITEM_BASE_CODE)
            .Get()
            .then(response => {
                updateBase(response.body.codigos.map((value: any) => {
                    return { value: value, label: value };
                }))
            })
    }
    const handleMarca = async () => {
        await new RestUseCase(`${ENDPOINT_MANUFACTURER}/marcas`).Get().then((response) => {
            updateMarca(
                (response.body || []).map((value: any) => {
                    return { value: value.id, label: String(value.siglaMarca || value.id) };
                })
            );
        });
    };
    useEffect(() => {
        handleFilial();
        handleDiscountGroup();
        handleRangeProfitability();
        handleBase();
        handleMarca();
    }, []);
    useEffect(() => {
        IndicatodFilterPlanningAdapter.map((value) => {
            if (value.label === "Filial") {
                value.field[1].optionsInput = filial;
            }

            if (value.label === "UF") {
                value.field[1].optionsInput = uf;
            }

            if (value.label === "Marca") {
                value.field[1].optionsInput = marca;
            }

            if (value.label === "Grupo de desconto") {
                value.field[1].optionsInput = discountGroup;
            }

            if (value.label === "Base") {
                value.field[1].optionsInput = base;
            }

            if (value.label === "Lucratividade do fornecedor") {
                value.field[1].optionsInput = rangeProfitability;
            }

            if (value.label === 'Meses da última venda') {
                const fetchOptions = value.field[1].fetchOptions;
                if (fetchOptions && loggedUserData?.companyId) {
                    fetchOptions(loggedUserData.companyId).then((options: { label: string; value: number }[]) => {
                        value.field[1].optionsInput = options;
                    });
                }
            }
            
            if (value.label === 'Meses da última compra') {
                const fetchOptions = value.field[1].fetchOptions;
                if (fetchOptions && loggedUserData?.companyId) {
                    fetchOptions(loggedUserData.companyId).then((options: { label: string; value: number }[]) => {
                        value.field[1].optionsInput = options;
                    });
                }
            }
        });

        IndicatodFilterPlanningAdapter.sort(function (a, b) {
            return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
    }, [filial, uf, marca, discountGroup, base, rangeProfitability]);

    const END_POINT_INDICATOR_MONTHS = getEnv("REACT_APP_END_POINT_INDICATOR_MONTHS")!
    const [availableMonths, updateAvailableMonths] = useState<String[]>([]);
    const getAvailableMonths = async () => {
        await new RestUseCase(END_POINT_INDICATOR_MONTHS)
            .Get()
            .then((response) => updateAvailableMonths(response.body));
    };
    useEffect(() => {
        getAvailableMonths();
    }, []);

    return (
        <>
            {showScreen ? (
                <IndicatorPageV2
                    list={async function (params: {
                        type: string;
                        pagination: string;
                        model?: any;
                        metric: string;
                        period: string[];
                        grouping: string;
                        quantity: number;
                        size: number;
                        checkByDateOf: string;
                        filter: any;
                    }): Promise<any> {
                        let url: string = "";

                        if (params.type === "OBS") {
                            url =
                                ENDPOINT_TABLE_PUNCTUATION! +
                                `/${params.checkByDateOf}?quantidade=${params.quantity}&tamanho=${params.size}${params.period}&metrica=${params.metric}`;
                        } else {
                            url =
                                ENDPOINT_TABLE_PUNCTUATION! +
                                `/${params.grouping}?metrica=${params.metric}${params.period}`;
                        }

                        const response = await new RestUseCase(url).Post({
                            data: params.filter,
                        });
                        return response.body;
                    }}
                    listByIdPlanning={async function (): Promise<any> { }}
                    listAllPlanning={async function (): Promise<any> {
                        const response = await new RestUseCase(
                            ENDPOINT_PLANNING!
                        ).Get();
                        return handleRequest(response);
                    }}
                    createPlanning={async function (
                        params?: any
                    ): Promise<any> {
                        params.idEmpresa = loggedUserData?.companyId
                        const response = await new RestUseCase(
                            ENDPOINT_PLANNING!
                        ).Post({ data: params });
                        return handleRequest(response);
                    }}
                    editPlanning={async function (params: {
                        model: any;
                        id: number;
                    }): Promise<any> {
                        params.model.idEmpresa = loggedUserData?.companyId
                        const response = await new RestUseCase(ENDPOINT_PLANNING! + '/' + params.id).Put({ data: params.model });
                        return handleRequest(response);
                    }}
                    removePlanning={async function (
                        params?: any
                    ): Promise<any> {
                        const response = await new RestUseCase(
                            ENDPOINT_PLANNING! + "/" + params.idFilter
                        ).Delete();
                        return handleRequest(response);
                    }}
                    optionsFiltersDefault={IndicatodFilterPlanningAdapter}
                    exportFileExcel={async function (params: {
                        type: string;
                        pagination: string;
                        model?: any;
                        metric: string;
                        period: string[];
                        grouping: string;
                        quantity: number;
                        size: number;
                        checkByDateOf: string;
                        filter: any;
                    }): Promise<any> {
                        const url =
                            ENDPOINT_EXCEL! +
                            `${params.checkByDateOf}?quantidade=${params.quantity}&tamanho=${params.size}${params.period}&metrica=${params.metric}`;

                        const response = await new RestUseCase(
                            `${url}`
                        ).Post({
                            responseType: "blob",
                            data: params.filter ? params.filter : undefined
                        });
                        return handleRequest(response);
                    }}
                    filiais={filial}
                    availableMonths={availableMonths}
                />
            ) : (
                <ErrorNotAuthorizedPage />
            )}
        </>
    );
};
